export default __webpack_public_path__ + "static/media/Affordable.ce279b86.svg";